import axios from "axios";

const profileService = {
  async fetchInfo() {
    return axios.get('/profile/api/info');
  }
};

export default profileService;